(()=>{'use strict';
if(window.AWOwnedReviewSubmitP1?.version)return;
const V='1.1.0-p1-owned-proof-media',P='aw.proof.review.submit.v1',MP='aw.proof.review.media.v1',ENDPOINT='/apps/aw-garage-sync';
const MAX_FILES=4,MAX_BYTES=8*1024*1024,ALLOWED=new Set(['image/jpeg','image/png','image/webp']);
const field=(form,name)=>form.elements.namedItem(name);
const value=(form,name)=>{const el=field(form,name);return String(el?.value||'').trim()};
const logged=form=>value(form,'contact[Compte client connecté]').toLowerCase()==='oui';
const intRating=form=>{const raw=value(form,'contact[Note]');const n=parseInt(raw,10);return Number.isInteger(n)&&n>=1&&n<=5?n:0};
const mediaInput=form=>form.querySelector('[data-aw-owned-review-media]');
const mediaConsent=form=>form.querySelector('[data-aw-owned-review-media-consent]');
const mediaFiles=form=>[...(mediaInput(form)?.files||[])];
function status(form,message,kind='success'){
  let box=form.querySelector('[data-aw-owned-review-status]');
  if(!box){box=document.createElement('div');box.dataset.awOwnedReviewStatus='true';box.className=kind==='success'?'aw-product-reviews__form-success':'aw-product-reviews__form-errors';const btn=form.querySelector('[type="submit"]');btn?.before(box)}
  box.setAttribute('role',kind==='success'?'status':'alert');box.className=kind==='success'?'aw-product-reviews__form-success':'aw-product-reviews__form-errors';box.textContent=message;box.tabIndex=-1;box.focus({preventScroll:true});
}
function prioritizeOwned(root=document){
  root.querySelectorAll('.aw-product-reviews__grid').forEach(grid=>{
    const cards=[...grid.querySelectorAll(':scope > .aw-product-reviews__review')];
    const owned=cards.filter(card=>card.querySelector('.aw-product-reviews__verified'));
    if(!owned.length)return;
    owned.reverse().forEach(card=>grid.prepend(card));
  });
}
function nativeFallback(form,reason){
  try{window.AWAnalytics?.track?.('p1_owned_review_native_fallback',{version:V,reason})}catch(_){}
  form.dataset.awOwnedReviewNativeFallback='true';
  HTMLFormElement.prototype.submit.call(form);
}
async function postJson(body,timeout=12000){
  const ctrl=new AbortController(),timer=setTimeout(()=>ctrl.abort(),timeout);
  try{
    const res=await fetch(ENDPOINT,{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify(body),signal:ctrl.signal});
    let data={};try{data=await res.json()}catch(_){}
    if(!res.ok||data?.ok!==true)throw Object.assign(new Error(data?.error||('http_'+res.status)),{status:res.status});
    return data;
  }finally{clearTimeout(timer)}
}
function validateMedia(form){
  const files=mediaFiles(form),consent=mediaConsent(form);
  if(files.length>MAX_FILES)throw new Error('Maximum 4 photos.');
  for(const file of files){
    if(!ALLOWED.has(String(file.type||'').toLowerCase()))throw new Error('Formats photo acceptés : JPEG, PNG ou WebP.');
    if(!Number.isFinite(file.size)||file.size<1||file.size>MAX_BYTES)throw new Error('Chaque photo doit faire 8 Mo maximum.');
  }
  if(files.length&&consent?.checked!==true)throw new Error('Autorisez la publication des photos après validation, ou retirez les photos.');
  return files;
}
async function uploadMedia(form){
  const files=validateMedia(form);
  if(!files.length)return {fileIds:[],receipt:''};
  status(form,'Téléversement sécurisé des photos en cours…');
  const staged=await postJson({protocol:MP,action:'review-media-stage',files:files.map(f=>({filename:f.name,mimeType:f.type,size:f.size}))},12000);
  if(!Array.isArray(staged.targets)||staged.targets.length!==files.length)throw new Error('media_stage_incomplete');
  for(let i=0;i<files.length;i++){
    const target=staged.targets[i],data=new FormData();
    for(const p of target.parameters||[])data.append(p.name,p.value);
    data.append('file',files[i],target.filename||files[i].name);
    const ctrl=new AbortController(),timer=setTimeout(()=>ctrl.abort(),30000);
    try{
      const res=await fetch(target.url,{method:'POST',body:data,signal:ctrl.signal});
      if(!res.ok)throw new Error('media_upload_http_'+res.status);
    }finally{clearTimeout(timer)}
  }
  const finalized=await postJson({protocol:MP,action:'review-media-finalize',tickets:staged.targets.map(t=>t.ticket)},15000);
  if(!Array.isArray(finalized.fileIds)||finalized.fileIds.length!==files.length||!finalized.receipt)throw new Error('media_finalize_incomplete');
  return {fileIds:finalized.fileIds,receipt:finalized.receipt};
}
async function submitOwned(form){
  const consent=field(form,'contact[Autorisation publication]');
  const media=await uploadMedia(form);
  const payload={
    protocol:P,action:'review-claim',
    review:{
      productId:value(form,'contact[Produit GID]'),
      displayName:value(form,'contact[name]'),
      rating:intRating(form),
      title:value(form,'contact[Titre avis]'),
      body:value(form,'contact[body]'),
      orderReferenceHint:value(form,'contact[Numéro de commande AW]'),
      publicationConsent:Boolean(consent?.checked),
      submittedAt:new Date().toISOString(),
      contextReplica:value(form,'contact[Réplique ou configuration]'),
      contextConfiguration:value(form,'contact[Montage / configuration]'),
      usageContext:value(form,'contact[Usage principal]'),
      customerMedia:media.fileIds,
      customerMediaReceipt:media.receipt,
      customerMediaConsent:media.fileIds.length?Boolean(mediaConsent(form)?.checked):false
    }
  };
  const data=await postJson(payload,12000);
  if(data?.protocol!==P)throw new Error('review_protocol_mismatch');
  const verified=data.purchaseVerification==='VERIFIED';
  status(form,verified
    ? (media.fileIds.length?'Merci. Votre avis et vos photos ont été reçus, et l’achat a été vérifié côté Assassin Workshop. Ils sont enregistrés en attente et doivent être validés manuellement par Assassin Workshop avant toute publication.':'Merci. Votre avis a été reçu et l’achat a été vérifié côté Assassin Workshop. Il est enregistré en attente et doit être validé manuellement par Assassin Workshop avant toute publication.')
    : (media.fileIds.length?'Merci. Votre avis et vos photos ont été reçus. La vérification d’achat reste en attente ; rien n’est publié automatiquement.':'Merci. Votre avis a été reçu. La vérification d’achat est en attente de rapprochement ou de relecture AW, et rien n’est publié automatiquement.'));
  form.reset();
  try{window.AWAnalytics?.track?.('p1_owned_review_received',{version:V,purchase_verification:data.purchaseVerification||'PENDING',claim_state:data.claimState||'RECEIVED',media_count:media.fileIds.length})}catch(_){}
  return true;
}
function bind(form){
  if(form.dataset.awOwnedReviewBound==='true')return;
  form.dataset.awOwnedReviewBound='true';
  if(logged(form)){
    const panel=form.querySelector('[data-aw-owned-review-media-panel]');if(panel)panel.hidden=false;
    const input=mediaInput(form),consent=mediaConsent(form);
    const sync=()=>{if(consent)consent.required=mediaFiles(form).length>0};
    input?.addEventListener('change',sync);sync();
  }
  form.addEventListener('submit',async e=>{
    if(form.dataset.awOwnedReviewNativeFallback==='true'||!logged(form))return;
    e.preventDefault();
    const btn=form.querySelector('[type="submit"]');
    if(btn?.disabled)return;
    try{validateMedia(form)}catch(err){status(form,String(err?.message||'Photos invalides.'),'error');return}
    if(!form.checkValidity()){form.reportValidity();return}
    if(btn)btn.disabled=true;
    const hadMedia=mediaFiles(form).length>0;
    try{await submitOwned(form)}
    catch(err){
      if(hadMedia){status(form,'L’envoi sécurisé des photos ou de l’avis a échoué. Rien n’a été publié. Réessayez sans perdre votre texte.','error');return}
      nativeFallback(form,String(err?.message||'proxy_unavailable'));return
    }finally{if(btn)btn.disabled=false}
  });
}
function start(){prioritizeOwned();document.querySelectorAll('form.aw-product-reviews__form').forEach(bind)}
window.AWOwnedReviewSubmitP1={version:V,protocol:P,mediaProtocol:MP,endpoint:ENDPOINT,prioritizeOwned};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
document.addEventListener('shopify:section:load',e=>{prioritizeOwned(e.target);e.target.querySelectorAll?.('form.aw-product-reviews__form').forEach(bind)});
})();